import React from 'react';
import { QbusControlPanel } from '../../../../../components/Qbus';
import { getLocationId } from '../../../utils/locationTransformers';

const DomoticsTab = ({ selectedLocation, t }) => (
  <QbusControlPanel
    locationId={getLocationId(selectedLocation)}
    locationName={selectedLocation?.friendlyName || selectedLocation?.name}
  />
);

export default DomoticsTab;
